<section>
  <div class="border_container">
    <div class="row align-items-center border mx-0 p-1">
      <div class="col d-flex justify-content-end">
        <app-custom-button [label]="'Agregar Forma Pago'" [severity]="'success'" [disabled]="disabledDetail"
          [width]="'9rem'" (onClick)="getFormView(true)"></app-custom-button>
      </div>
    </div>
    <div [hidden]="!isFormView">
      <form novalidate [formGroup]="formCashReceiptPayment">
        <div class="row px-1 mb-2">
          <div class="col field-payment-method">
            <app-custom-select formControlName="wayToPayId" [labelText]="'Forma de Pago'" [list]="listWayToPay"
              [required]="true" [recovery]="true" (onChangeSelect)="changeWayToPay($event)">
            </app-custom-select>
          </div>
          <div class="col field-payment-value">
            <app-custom-input-decimal formControlName="paidValue" [labelText]="'Valor de Pago'" [required]="true">
            </app-custom-input-decimal>
          </div>
          <div class="col fields-buttons">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'success'"
              [disabled]="disabledDetail" (onClick)="send()">
            </app-custom-button>
          </div>
          <div class="col fields-buttons">
            <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'" (onClick)="cancel()">
            </app-custom-button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <app-custom-table [headers]="paymentHeader" [data]="paymentData" [actions]="tableActions"
        [showCheckbox]="!this.disabledDetail" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>